import Box from "@mui/material/Box";

export default function ProgressBlock({ checked }) {
  return (
    <Box
      sx={{
        backgroundColor: checked ? "#f49e2d" : "#35323d",
        height: 20,
        width: 90,
        borderRadius: 25,
      }}
    ></Box>
  );
}
